import {
  SHOW_PHOTO_GALLERY,
  CLEAN_PHOTO_GALLERY,
  SET_PHOTO_INDEX,
} from '../actionTypes/photoGallery';

export const showPhotoGallery = (photoList, currentIndex) => ({
  type: SHOW_PHOTO_GALLERY,
  photoList,
  currentIndex,
});

export const closePhotoGallery = () => ({
  type: CLEAN_PHOTO_GALLERY,
});

export const setCurrentGalleryIndex = currentIndex => ({
  type: SET_PHOTO_INDEX,
  currentIndex,
});
